import OrderTransaction from "../components/Common/dtos/OrderTransactionDto";
import { QueryOptions } from "../components/Common/useQuery";
import useUserOrEmployeeQuery from "../components/Common/useUserOrEmployeeQuery";
import { useUserOrKaEmployee } from "../components/UserAccess/useUserOrKaEmployee";

const useOrderTransactionsByOrder = (orderId: string, unit: string, options?: QueryOptions<OrderTransaction[]>) => {
  const { selectedBusiness } = useUserOrKaEmployee();

  return useUserOrEmployeeQuery<OrderTransaction[]>({
    path: `api/businesses/${selectedBusiness?.id}/orders/${orderId}/orderTransactions?unit=${unit}`
  }, options);
}

export default useOrderTransactionsByOrder;
